import { createReducer } from "reduxsauce"
import { takeLatest, select, put } from "redux-saga/effects"
import actionCreator from "helpers/actionCreator"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { getCategoryItemsSubset } from "./selectors/data"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzePerformance", {
  toggle: {
    props: ["id", "currentState"],
    track: true,
    trackType: "analyze-performance-graph-legend-factor",
    trackPayload: ({ id, currentState }) => ({ factor: id, state: currentState ? "on" : "off" }),
  },
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  setDisplayType: {
    props: ["displayType"],
    track: true,
    trackType: "analyze-performance-category-selection",
    trackPayload: ({ displayType }) => ({ type: displayType }),
  },
  trackCSVDownload: {
    track: true,
    trackType: "analyze-performance-graph-timeseries-download",
  },
  toggleOnly: {
    props: ["id", "state"],
    track: true,
    trackType: "analyze-performance-graph-legend-factor",
    trackPayload: ({ id, state }) => ({ factor: id, state }),
  },
  toggleOnlySuccess: ["selected", "only", "items"],
  setMetricType: {
    props: ["metricType"],
    track: true,
    trackType: "analyze-performance-metric-type-selected",
    trackPayload: ({ metricType }) => ({ metricType }),
  },
})

const DEFAULT_STATE = {
  displayType: "total",
  focusedChartLine: null,
  disabled: {},
  only: null,
}

function handleSetDisplayType(state, { displayType }) {
  const newState = { displayType, only: null }

  if (displayType !== "total" && displayType !== "factors" && state.disabled[`${displayType}_total`] === undefined) {
    newState.disabled = { ...state.disabled, [`${displayType}_total`]: true }
  }

  return { ...state, ...newState }
}

function handleToggle(state, { id }) {
  let disabled
  let focusedChartLine

  if (state.disabled[id]) {
    focusedChartLine = id
    disabled = { ...state.disabled, [id]: false }
  } else {
    focusedChartLine = null
    disabled = { ...state.disabled, [id]: true }
  }
  return { ...state, disabled, focusedChartLine, only: null }
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

function handleToggleOnlySuccess(state, { selected, only, items }) {
  const disabled = {}
  let focusedChartLine = null
  let onlyDisplay = null

  if (only) {
    focusedChartLine = selected
    onlyDisplay = selected
    items.forEach(item => {
      if (item.id !== selected) {
        disabled[item.id] = true
      }
    })
  }

  return { ...state, disabled, focusedChartLine, only: onlyDisplay }
}

function handleSetModel(state) {
  return { ...state, only: null, focusedChartLine: null }
}

function handleSetMetricType(state, { metricType }) {
  return { ...state, selectedMetricType: metricType }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE]: handleToggle,
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.SET_DISPLAY_TYPE]: handleSetDisplayType,
  [Types.TOGGLE_ONLY_SUCCESS]: handleToggleOnlySuccess,
  [BaseTypes.SET_MODEL]: handleSetModel,
  [Types.SET_METRIC_TYPE]: handleSetMetricType,
})

function* handleToggleOnly({ id }) {
  const { items, only } = yield select(state => ({
    items: getCategoryItemsSubset(state),
    only: state.modules.analyzePerformance.only,
  }))

  yield put(Creators.toggleOnlySuccess(id, only !== id, items))
}

export function* saga() {
  yield takeLatest(Types.TOGGLE_ONLY, handleToggleOnly)
}
